






import {
  defineNuxtComponent,
  onMounted,
  ref,
  watch,
  PropType
} from '~/utils/nuxt3-migration'
import {
  Chart,
  LineController,
  CategoryScale,
  LinearScale,
  PointElement,
  Tooltip,
  LineElement,
  Colors,
  Filler,
  Legend,
  ChartConfiguration
} from 'chart.js'

Chart.register(
  LineController,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Colors,
  Tooltip,
  Filler,
  Legend
)

export default defineNuxtComponent({
  props: {
    config: {
      type: Object as PropType<ChartConfiguration>,
      required: true
    }
  },
  setup(props) {
    const chart = ref<HTMLCanvasElement | null>(null)
    let chartInstance: Chart

    watch(
      () => props.config,
      (newConfig: ChartConfiguration) => {
        if (!chartInstance || !newConfig) {
          return
        }

        const { options, data } = newConfig

        if (!options || !data) {
          return
        }

        if (options) {
          chartInstance.options = options
        }

        if (data) {
          chartInstance.data = data
        }

        chartInstance.update()
      },
      { deep: true }
    )

    onMounted(() => {
      if (chart.value) {
        // eslint-disable-next-line no-new
        chartInstance = new Chart(chart.value, props.config)
      }
    })

    return {
      chart
    }
  }
})
